import React, { useState, useEffect } from 'react';
import { fetchInvoiceShipments } from '../../services/api';
import LoadingButton from '../LoadingButton/LoadingButton';
import DateInput from '../DateInput/DateInput';
import './creditShipmentSelector.css';

export default function CreditShipmentSelector({ invoice_number, onConfirm, onClose }) {
  const [shipments, setShipments] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [billingDate, setBillingDate] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedData = await fetchInvoiceShipments(invoice_number);
        if (fetchedData && Array.isArray(fetchedData.shipments)) {
          const shipments = fetchedData.shipments;
          const extractedData = shipments.map(shipment => ({
            ...shipment,
            new_client_price: shipment.client_price,
            selected: false,
          }));
          setShipments(extractedData);
        } else {
          setShipments([]);
          console.error('La réponse ne contient pas de tableau "results"');
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        setShipments([]);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (index, field, value) => {
    const updatedShipments = [...shipments];
    updatedShipments[index][field] = value;
    updatedShipments[index]['selected'] = value - shipments[index]['client_price'] !== 0;
    setShipments(updatedShipments);
  };

  const handleToggleSelect = index => {
    const newShipments = [...shipments];
    const isNowSelected = !newShipments[index].selected;
    newShipments[index].selected = isNowSelected;
    newShipments[index].new_client_price = isNowSelected ? 0 : newShipments[index].client_price;
    setShipments(newShipments);
  };

  const handleTotalCredit = () => {
    const updatedShipments = shipments.map(shipment => ({
      ...shipment,
      new_client_price: 0,
      selected: true,
    }));
    setShipments(updatedShipments);
  };

  const handleConfirmClick = async () => {
    const FilterShipments = shipments => {
      const filteredShipments = shipments.filter(
        shipment => shipment.new_client_price - shipment.client_price !== 0 && shipment.selected
      );
      return filteredShipments;
    };
    let selected = FilterShipments(shipments);
    selected = selected.map(shipment => ({
      ...shipment,
      client_price: shipment.new_client_price - shipment.client_price,
    }));
    await onConfirm(selected, showPreview, billingDate || null);
  };

  return (
    <div className="overlay">
      <div className="shipment-selector-content">
        <div>
          <span className="overlay-close" onClick={onClose}>
            &times;
          </span>
          <div className="shipments-list credit-shipment-selector">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>N° dossier</th>
                  <th>Prix client</th>
                  <th>Différence</th>
                </tr>
              </thead>
              <tbody>
                {shipments.map((shipment, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={shipment.selected}
                        onChange={() => handleToggleSelect(index)}
                      />
                    </td>
                    <td onClick={() => handleToggleSelect(index)}>{shipment.shipment_number}</td>
                    <td>
                      <input
                        className="credit-shipment-selector-input"
                        type="number"
                        name="new_client_price"
                        value={shipment.new_client_price}
                        onChange={e => handleChange(index, 'new_client_price', e.target.value)}
                      />
                    </td>
                    <td onClick={() => handleToggleSelect(index)}>
                      {shipment.new_client_price - shipment.client_price}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="shipment-selector-options credit-shipment-selector">
            <label className="preview-checkbox">
              <input
                type="checkbox"
                checked={showPreview}
                onChange={e => setShowPreview(e.target.checked)}
              />
              Afficher l'aperçu PDF
            </label>
            <label className="billing-date-label">
              Date de facturation :
              <DateInput
                name="billing_date"
                value={billingDate}
                onChange={e => setBillingDate(e.target.value)}
                disablePastDateWarning
                disableFutureDates
              />
            </label>
          </div>
          <div className="shipment-selector-buttons credit-shipment-selector">
            <button type="button" onClick={handleTotalCredit}>
              Avoir total
            </button>
            <LoadingButton onClick={handleConfirmClick}>Éditer l'avoir</LoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
}
